import React from "react";
import TimeIcon from "../Assets/Icons/clockIcon.svg";
import AiProjectImg from '../Assets/TeamProfile.png'

export default function AiProjectCard(props) {
  return (
    <div className="w-full border-[1px] rounded-[12px] border-[#E5E7EB] py-4 px-4 bg-white cursor-pointer hover:bg-gray-50" onClick={() => props?.handleClick && props?.handleClick()}>
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2">
        <img className="w-[3.1rem] h-[3.1rem] rounded-[5px]" src={AiProjectImg} />
          <div className="flex flex-col gap-[1px]">
            <p className="text-[1.2rem] font-[500] text-[#111928]">
              {props.projecttitle}
            </p>
            <p className="text-[1rem] text-[#6B7280]">{props.location}</p>
          </div>
        </div>
        <div className="px-3 py-1 w-fit rounded-[6px] bg-[#F3F4F6] flex items-center gap-2">
          <img src={TimeIcon} />
          <p className="text-[0.94rem] text-[#111928] font-500">
            Due in <span>{props.duetime}</span>
          </p>
        </div>
      </div>
      <div>
        <p className="text-[0.94rem] text-[#6B7280] mt-3">{props.desc}</p>
        <p className="text-[0.94rem] text-[#6B7280] mt-3">Assigned Team</p>
        <div className="flex items-center gap-2 mt-1 ">
          <img className="w-[1.5rem] h-[1.5rem]" src={props.teamimg} />
          <p className="text-[0.94rem] font-[500] text-[#111928]">
            {props.teamname}
          </p>
        </div>
      </div>
    </div>
  );
}
